import { LOCALCALENDAR_ENTRY_TYPENAME } from './constants';

/**
 * Returns whether provided calendar entry is an owned LocalCalendarEntry (i.e. a calendar
 * the current account owns, not a delegate/shared/linked/group calendar).
 * @param calendarEntry the calendar entry
 * @returns true if calendar entry is a LocalCalendarEntry
 */
export function isLocalCalendarEntry(calendarEntry: {
    __typename?: string;
    CalendarName?: string;
}): boolean {
    return calendarEntry?.__typename === LOCALCALENDAR_ENTRY_TYPENAME;
}
